<template>
    <div id="spring">
      <div class="top">
        <div class="cloud x1"></div>
        <div class="cloud x2"></div>
        <div class="cloud x3"></div>
        <div class="cloud x4"></div>
        <div class="cloud x5"></div>
      </div>
      <div class="bottom">
        <div class="petals">
          <img :src="'./img/petals.png'">
          <img :src="'./img/petals.png'">
        </div>
      </div>
    </div>
</template>
<script>
export default {
}
</script>
